import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import { TYPES_VIEW } from '../../constans/types-view';
import { Schedule } from '../../components/schedule';
import { Preloader } from '../../components/preloader';
import { Navigation } from '../../components/navigation';
import { connectWSAction, initWSAction } from '../../ws/actions';
import { getFiltersParamsAction } from '../../components/schedule/actions';
import { getScheduleWSAction } from '../../components/schedule/actionsWS';
import {
    switchTypeAction,
    switchDateAction,
    switchSpecialityAction
} from '../../components/filter/actions';
import './style.scss';

class ServicesModule extends React.Component {
    state = {
        openShedule: false,
        openServiceID: null
    }

    componentDidMount() {
        const { dispatch, filter } = this.props;

        dispatch(getFiltersParamsAction());
        dispatch(switchTypeAction(TYPES_VIEW[1]));
        dispatch(connectWSAction({ ...filter, typeView: TYPES_VIEW[1] }));
    }

    onOpenShedule = (serviceID) => {
        const { dispatch, schedule, ws } = this.props;
        const { services, filter } = schedule;
        const service = services.filter(item => +item.id === serviceID)[0];

        dispatch(switchSpecialityAction({ label: service.name, value: +service.id }));
        dispatch(switchDateAction(moment()));
        dispatch(getScheduleWSAction({
            ...filter,
            date: moment(),
            speciality: { label: service.name, value: +service.id },
            typeView: TYPES_VIEW[1]
        }, ws));

        this.setState({
            openShedule: true,
            openServiceID: serviceID
        });
    }

    kitcut = (text, limit) => {
        let newText = text;
        newText = newText.trim();
        if (newText.length <= limit) return newText;

        newText = text.slice(0, limit);

        return `${newText.trim()}...`;
      }

    render() {
        const { openShedule, openServiceID } = this.state;
        const {
            dispatch,
            schedule,
            filter,
            ws
        } = this.props;
        const { services } = schedule;
        const { typeView } = filter;
        const isMobile = window.matchMedia('(max-width: 991px)').matches;

        if (ws.ws) {
            dispatch(initWSAction(ws, typeView));
        }

        if (services === null) {
            return <Preloader />;
        }

        return (
            <div className="module-services">
                {services.map(item => (
                    <div className="module-services__item" key={item.id}>
                        <p className="module-services__item_name">{item.name}</p>
                        <div className="module-services__item__info">
                            <div className="module-services__item__info_image" style={{ backgroundImage: item.image !== '' ? `url('${item.image}')` : "url('/app/dist/assets/placeholder.jpg')" }} />
                            <div className="module-services__item__info__content">
                                <p className="module-services__item__info__content_text">{isMobile ? this.kitcut(item.description, 160) : item.description}</p>
                                {!isMobile ? (
                                    <div className="module-services__item__info__content__navs">
                                        <a href={item.link} className="module-services__item__info__content__navs_link">подробнее об услуге</a>
                                        <button type="button" className="module-services__item__info__content__navs_schedule" onClick={() => this.onOpenShedule(+item.id)}>посмотреть свободные места на лечение</button>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        {isMobile ? (
                            <div className="module-services__item__info__content__navs">
                                <a href={item.link} className="module-services__item__info__content__navs_link">подробнее об услуге</a>
                                <button type="button" className="module-services__item__info__content__navs_schedule" onClick={() => this.onOpenShedule(+item.id)}>посмотреть свободные места на лечение</button>
                            </div>
                        ) : null}
                        {openShedule && openServiceID === +item.id ? (
                            <div className="module-services__item_schedule">
                                <Navigation />
                                <Schedule />
                            </div>
                        ) : null}
                    </div>
                ))}
            </div>
        );
    }
}

ServicesModule.propTypes = {
    dispatch: PropTypes.func.isRequired,
    filter: PropTypes.object.isRequired,
    schedule: PropTypes.object.isRequired,
    ws: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    filter: state.filter,
    schedule: state.schedule,
    ws: state.ws
});

export default connect(mapStateToProps)(ServicesModule);
